export default "__VITE_ASSET__Cv5JGjN6__"